module.exports = __webpack_public_path__ + "img/Wally Javier.5a109379.jpg";